import { Download, Info } from 'lucide-react';

interface TimetableFooterProps {
  /**
   * The first working day of the week on screen, as printed. The timetable has
   * no "effective from" date of its own, so the footer names the week shown
   * rather than claiming when the timetable took effect. Empty until it loads.
   */
  weekOf: string;
  onDownload?: () => void;
}

export function TimetableFooter({ weekOf, onDownload }: TimetableFooterProps) {
  const handleDownload = () => {
    if (onDownload) {
      onDownload();
      return;
    }
    // Default print / download action
    window.print();
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pt-2">
      {/* Left Info Disclaimer */}
      <div className="flex items-center gap-2 text-xs text-ink-3">
        <Info className="h-4 w-4 shrink-0 text-ink-3" />
        <span>
          {weekOf && `Week of ${weekOf}. `}Changes will be updated automatically.
        </span>
      </div>

      {/* Right Download Button */}
      <div className="print:hidden">
        <button
          type="button"
          onClick={handleDownload}
          className="flex items-center gap-2 h-9 px-4 rounded-[10px] bg-indigo-600 hover:bg-indigo-700 text-white text-sm sm:text-base font-bold transition-all shadow-xs cursor-pointer active:scale-95"
        >
          <Download className="h-4 w-4" />
          <span>Download Timetable</span>
        </button>
      </div>
    </div>
  );
}
